// utils/searchUtils.ts
import React from 'react';


/**
 * Highlights search terms in text with <span className="highlight">
 */
export function highlightSearchTerm(text: string, searchTerm: string): React.ReactNode {
    if (!searchTerm.trim()) return text;
    
    const regex = new RegExp(`(${searchTerm.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')})`, 'gi');
    const parts = text.split(regex);
    
    return parts.map((part, index) => 
        regex.test(part) ? 
            <span key={index} className="highlight">{part}</span> : 
            part
    );
}

/**
 * Search function for assets by name only
 */
export const searchAssetsByName = (assets: any[], searchTerm: string, formatAssetForDisplay: (asset: any) => { title: string; subtitle: string; details: string[]; type: string; distance?: number; coordinates?: number[]; }): any[] => {
    if (!searchTerm.trim()) return assets;
    
    const term = searchTerm.trim().toLowerCase();
    return assets.filter(asset => {
        const assetName = asset?.name || 'Unnamed Asset';
        return assetName.toLowerCase().includes(term);
    });
};

/**
 * Search function for assets using display info (name, type, details)
 */
export const searchAssetsByDisplayInfo = (assets: any[], searchTerm: string, formatFunction: (asset: any) => any): any[] => {
    if (!searchTerm.trim()) return assets;
    
    const term = searchTerm.toLowerCase();
    return assets.filter(asset => {
        const displayInfo = formatFunction(asset);
        
        return (
            displayInfo.title.toLowerCase().includes(term) ||
            displayInfo.type.toLowerCase().includes(term) ||
            displayInfo.details.some((detail: string) => 
                detail.toLowerCase().includes(term)
            )
        );
    });
};
